export const bankStatusOptions = [
  { value: 1001, label: 'Active' },
  { value: 1002, label: 'Inactive' },
];
